import {spawnSync} from 'node:child_process';

import chalk from 'chalk';
import inquirer from 'inquirer';

export interface Template {
  name: string;
  repo: string;
}

/**
 * Prompt the user to select a template and clone it.
 * @param templates Array of templates to choose from
 */
export const chooseAndCloneTemplate = async (templates: Template[]): Promise<void> => {
  if (templates.length === 0) {
    process.stderr.write(chalk.red('No templates available\n'));

    return;
  }

  const {template} = await inquirer.prompt<{template: string}>([
    {
      choices: templates.map((t) => t.name),
      message: 'Select a template:',
      name: 'template',
      type: 'list'
    }
  ]);

  const selected = templates.find((t) => t.name === template);

  if (!selected) {
    process.stderr.write(chalk.red('Template not found!\n'));

    return;
  }

  process.stdout.write(chalk.green(`\nCloning ${selected.name}...\n`));
  const result = spawnSync('git', ['clone', selected.repo, './'], {stdio: 'inherit'});

  if (result.error) {
    process.stderr.write(chalk.red(result.error.message) + '\n');
  }
};
